import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import * as fromServiceGroupCategories from './service-group-categories.actions';
import { ServiceGroupCategory } from '@quorum/models/xs-resource';
import { ServiceGroupCategoriesState } from './service-group-categories.interfaces';
@Injectable()
export class ServiceGroupCategoriesEffects {
  
  getServiceGroupCategoriesFromServer = createEffect(() => this.dataPersistence.fetch(
    fromServiceGroupCategories.GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER,
    {
      run: (action: fromServiceGroupCategories.GetServiceGroupCategoriesFromServer, state: any) => {
        if (state.svcDropdowns.serviceGroupCategories.ids.length === 0) {
          return this.apiService
            .get<ServiceGroupCategory[]>(`v/1/fixed-operations/service-group-categories`, {
              params: action.payload
            })
            .pipe(
              map((serviceGroupCategories: ServiceGroupCategory[]) => {
                return new fromServiceGroupCategories.GetServiceGroupCategoriesFromServerSuccess({
                  serviceGroupCategories: serviceGroupCategories
                });
              })
            );
        }
      },
      onError: (action: fromServiceGroupCategories.GetServiceGroupCategoriesFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServiceGroupCategoriesState>,
    private apiService: ApiService
  ) {}
}
